import { fetchMenuItems } from '../services/menuService';
import { setDefaultDateFnsOptions } from '../utils/helpers';
import { systemPermissionsReceived } from '../slices/permissionsSlice';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// async thunk
export const requestMenuData = createAsyncThunk(
  'menu/requestMenuData',
  async (_, { dispatch }) => {
    const response = await fetchMenuItems();
    const { menuName, menuGuide } = response.data;
    const { name, email, locale } = menuName;

    if (menuName && menuName.locale) {
      setDefaultDateFnsOptions({ locale: menuName.locale });
    }
    if (menuGuide) {
      dispatch(systemPermissionsReceived(menuGuide));
    }
    dispatch({ type: 'MENU_DATA_RECEIVED', data: response.data });

    if (menuName) {
      dispatch({
        type: 'USER_INFO_RECEIVED',
        initials: menuName.initials,
        name: menuName.name,
        email: menuName.email,
        locale: menuName.locale,
        organisation: menuName.organisation,
        champLinkPrefix: menuName.champLinkPrefix,
        created: menuName.created,
        isManagingCustomer: menuName.isManagingCustomer,
        employeeId: menuName.id,
      });
    }
    return {
      ...response.data,
      name,
      email,
      telemetryApiKey: menuGuide.telemetryApiKey,
      telemetryUrl: menuGuide.telemetryUrl,
      telemetryEnabled: menuGuide.telemetryEnabled,
      aiConnectionString: menuGuide.aiConnectionString,
      showSupport: menuGuide.showIntercom,
    };
  }
);

// slice
const rootMenuSlice = createSlice({
  name: 'rootMenu',
  initialState: {
    items: [],
    allowChangeOfChampLinkVisibility: false,
    disableUpload: true,
    adminSiteBaseUrl: '',
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(requestMenuData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(requestMenuData.fulfilled, (state, action) => {
        const data = action.payload;
        state.items = data.menuGuide?.items || [];
        state.allowChangeOfChampLinkVisibility =
          data.menuGuide?.allowChangeOfChampLinkVisibility || false;
        state.disableUpload = data.menuGuide?.disableUpload ?? true;
        state.adminSiteBaseUrl = data.menuGuide?.adminSiteBaseUrl || '';
        state.hasExternalUserDirectoryIntegration =
          data.menuGuide?.hasExternalUserDirectoryIntegration;
        state.organisationAllowsChampLogin =
          data.menuGuide?.organisationAllowsChampLogin;
        state.demoMode = data.menuGuide?.demoMode;
        state.timeZone = data.menuGuide?.timeZone;
        state.dateFormat = data.formatOptions?.dateFormat;
        state.timeFormat = data.formatOptions?.timeFormat;
        state.isLoading = false;
      })
      .addCase(requestMenuData.rejected, (state, action) => {
        console.error('Failed to fetch menu data:', action.error);
        state.isLoading = false;
      });
  },
});

export default rootMenuSlice.reducer;
export const rootMenuActions = rootMenuSlice.actions;
